import { useSelector } from 'react-redux';
import { getFeatureFlagValue } from 'src/features/featureFlag';
import { RootState } from 'src/store';
import { FeatureFlagKey } from 'src/ts/enums';

export const useFeatureFlag = (featureFlagKey: FeatureFlagKey): boolean => {
  // ITL-2681 PR-feedback finding #13: one `useSelector` per consumer keeps the
  // Redux subscription count to one per hook usage across 35+ feature modules.
  return useSelector((state: RootState) => getFeatureFlagValue(state, featureFlagKey));
};
